import { spacing, media, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-space-columns";
const left = objectWithClassName({
  [`@media (${media.queries.tablet.min})`]: {
    display: "flex"
  },
  "& > *:first-child": {
    [`@media (${media.queries.tablet.max})`]: {
      display: "none"
    },
    [`@media (${media.queries.tablet.min})`]: {
      marginRight: spacing["max"],
      width: "242px"
    }
  },
  "& > *:last-child": {
    [`@media (${media.queries.tablet.min})`]: {
      width: "calc(100% - 242px)"
    }
  },
  className: [
    `${classNamePrefix}-left`,
    /** @deprecated Use 'umd-layout-space-columns-left' instead */
    "umd-layout-interior-navigation"
  ]
});
const right = objectWithClassName({
  ...left,
  [`@media (${media.queries.tablet.min})`]: {
    display: "flex"
  },
  "& > *:first-child": {
    [`@media (${media.queries.tablet.min})`]: {
      width: `calc(100% - 322px)`
    }
  },
  "& > *:last-child": {
    paddingTop: spacing.md,
    borderTop: `1px solid ${color.black}`,
    [`@media (${media.queries.large.max})`]: {
      marginTop: spacing["3xl"]
    },
    [`@media (${media.queries.tablet.min})`]: {
      marginLeft: spacing["7xl"],
      width: "322px"
    }
  },
  className: [
    `${classNamePrefix}-right`,
    /** @deprecated Use 'umd-layout-space-columns-right' instead */
    "umd-layout-interior-sidebar"
  ]
});
export {
  left,
  right
};
//# sourceMappingURL=columns.js.map
